<template>
  <div class="captcha">
    <span>What is {{ randomNo1 }} + {{ randomNo2 }}?</span>
  </div>
</template>

<script>
export default {
  emits: ['totalCreated'],
  data () {
    return {
      minNo: 1,
      maxNo: 8,
      randomNo1: 0,
      randomNo2: 0,
      total: 0
    }
  },
  created () {
    this.randomNo1 = this.getRandomNum()
    this.randomNo2 = this.getRandomNum()
    this.total = this.randomNo2 + this.randomNo1
    this.$emit('totalCreated', this.total)
  },
  methods: {
    getRandomNum () {
      return Math.floor(Math.random() * (this.maxNo - this.minNo) + this.minNo)
    }
  }
}
</script>

<style scoped>
.captcha {
  white-space: pre;
}
</style>